<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  methods: {},
  created() {
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem('list', JSON.stringify(this.$store.state))
    })

    try {
      sessionStorage.getItem('list') &&
        this.$store.replaceState(
          Object.assign(
            {},
            this.$store.state,
            JSON.parse(sessionStorage.getItem('list'))
          )
        )
    } catch (err) {
      console.log(err)
    }

    sessionStorage.removeItem('list')
  }
}
</script>

<style>
html,
body {
  width: 100%;
  /* height: 100%; */
  background-color: #fff;
  overflow-x: hidden;
  overflow-y: auto;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
  background-color: #fff;
  width: 100%;
  /* height: 100%; */
}

* {
  padding: 0;
  margin: 0;
}
</style>
